// extracted by mini-css-extract-plugin
export default {"swiper-slide-active":"CarSelection_swiper-slide-active__AT9lV","title":"CarSelection_title__sbKLR"};